import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { queryClient } from 'index';
import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import { getToastErrorMessage, LogyxError } from 'services/api/errors';
import { ReactMutationKeys } from 'services/api/reactMutationKeys';
import { updateCompany } from 'services/CompanyService';
import { useTranslation } from 'react-i18next';
import { IEditCompanyDataDTO } from '../types';

export const useEditCompany = (companyId: number) => {
  const { t } = useTranslation();
  return useMutation(
    (editCompanyDTO: IEditCompanyDataDTO) =>
      updateCompany(companyId, editCompanyDTO),
    {
      onSuccess: () => {
        toast.success(t('Company data edited'), {
          className: ReactMutationKeys.UPDATE_COMPANY,
        });
        queryClient.invalidateQueries([ReactQueryKeys.GET_COMPANY]);
      },
      onError: (error: LogyxError) => {
        toast.error(getToastErrorMessage(error), {
          toastId: ReactMutationKeys.UPDATE_COMPANY,
        });
      },
      mutationKey: ReactMutationKeys.UPDATE_COMPANY,
    }
  );
};
